import React, {useContext, useEffect, useState} from "react";

import { makeStyles } from "@material-ui/core/styles";
import { green } from "@material-ui/core/colors";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";

import { i18n } from "../../translate/i18n";
import TextField from "@material-ui/core/TextField";
import {toast} from "react-toastify";
import CryptoJS from "crypto-js";
import api from "../../services/api";
import toastError from "../../errors/toastError";
import {AuthContext} from "../../context/Auth/AuthContext";

const useStyles = makeStyles(theme => ({
	root: {
		display: "flex",
		flexWrap: "wrap",
	},
	textField: {
		marginRight: theme.spacing(1),
		flex: 1,
	},

	btnWrapper: {
		position: "relative",
	},

	buttonProgress: {
		color: green[500],
		position: "absolute",
		top: "50%",
		left: "50%",
		marginTop: -12,
		marginLeft: -12,
	},
	formControl: {
		margin: theme.spacing(1),
		minWidth: 120,
	},
	colorAdorment: {
		width: 20,
		height: 20,
	},
	multFieldLine: {
		display: "flex",
		"& > *:not(:last-child)": {
			marginRight: theme.spacing(1),
		},
	},
}));

const ChangePasswordModal = ({ open, onClose, userId, queueIds }) => {
	const classes = useStyles();
	const { user } = useContext(AuthContext);
	const [oldPassword, setOldPassword] = useState("");
	const [newPassword, setNewPassword] = useState("");
	const [confirmationPassword, setConfirmationPassword] = useState("");

	useEffect(() => {
		(async () => {

		})();

		return () => {

		};
	}, [open]);

	const handleClose = () => {
		setOldPassword("");
		setNewPassword("");
		setConfirmationPassword("");
		onClose();
	};

	function encryptData(data) {
		const secretKey = window.env?.REACT_APP_SECRET_KEY || process.env.REACT_APP_SECRET_KEY;
		return CryptoJS.AES.encrypt(data, secretKey).toString();
	}

	/*function encryptData(data) {
		const secretKey = window.env?.REACT_APP_SECRET_KEY || process.env.REACT_APP_SECRET_KEY;
		const key = CryptoJS.enc.Utf8.parse(secretKey); // Converter chave para formato correto

		const encrypted = CryptoJS.AES.encrypt(data, key, {
			mode: CryptoJS.mode.ECB, // 🔹 ECB não usa IV
			padding: CryptoJS.pad.Pkcs7
		});

		return encrypted.toString(); // Retorna a string criptografada em base64
	}*/

	function isStrongPassword(password) {
		const minLength = 8;
		const hasUpperCase = /[A-Z]/.test(password);
		const hasLowerCase = /[a-z]/.test(password);
		const hasNumber = /\d/.test(password);
		const hasSpecialChar = /[\W_]/.test(password);

		return (
			password.length >= minLength &&
			hasUpperCase &&
			hasLowerCase &&
			hasNumber &&
			hasSpecialChar
		);
	}

	function validatePassword(password) {
		if (password.length < 8) return "A senha deve ter no mínimo 8 caracteres.";
		if (!/[A-Z]/.test(password)) return "A senha deve ter pelo menos uma letra maiúscula.";
		if (!/[a-z]/.test(password)) return "A senha deve ter pelo menos uma letra minúscula.";
		if (!/\d/.test(password)) return "A senha deve ter pelo menos um número.";
		if (!/[\W_]/.test(password)) return "A senha deve ter pelo menos um caractere especial.";
	}

	const handleSave = async () => {
		if (!oldPassword || !newPassword || !confirmationPassword) {
			toast.error("Por favor, preencha todos os campos!");
			return;
		}

		if (newPassword !== confirmationPassword) {
			toast.error("Senhas preenchidas não coincidem!");
			return;
		}

		if (!isStrongPassword(newPassword)) {
			toast.warn(validatePassword(newPassword));
			return;
		}

		const criptedCurrentPass = encryptData(oldPassword);
		const criptedPass = encryptData(newPassword);

		try {
			await api.put(`/users/${userId}`, {
				currentPassword: criptedCurrentPass,
				password: criptedPass,
				queueIds,
				log: JSON.stringify({
					userId: user?.id,
					userName: user?.name + "."
				})
			});
			toast.success("Senha alterada com sucesso!");
			handleClose();
		} catch (e) {
			toastError(e);
		}
	}

	return (
		<div className={classes.root}>
			<Dialog open={open} onClose={handleClose} scroll="paper">
				<DialogTitle>
					Alterar senha
				</DialogTitle>
				<DialogContent dividers>
					<div className={classes.multFieldLine}>
						<TextField
							fullWidth
							label="Confirme a senha atual"
							variant="outlined"
							type="password"
							margin="dense"
							onChange={(e) => setOldPassword(e.target.value)}
							value={oldPassword}
						/>
					</div>

					<div className={classes.multFieldLine}>
						<TextField
							fullWidth
							label="Digite a nova senha"
							variant="outlined"
							type="password"
							margin="dense"
							onChange={(e) => setNewPassword(e.target.value)}
							value={newPassword}
						/>
					</div>

					<div className={classes.multFieldLine}>
						<TextField
							fullWidth
							label="Confirme a nova senha"
							variant="outlined"
							type="password"
							margin="dense"
							onChange={(e) => setConfirmationPassword(e.target.value)}
							value={confirmationPassword}
						/>
					</div>
				</DialogContent>
				<DialogActions>
					<Button
						onClick={handleClose}
						color="secondary"
						// disabled={isSubmitting}
						variant="outlined"
					>
						{i18n.t("queueModal.buttons.cancel")}
					</Button>
					<Button
						color="primary"
						onClick={handleSave}
						// disabled={isSubmitting}
						variant="contained"
						className={classes.btnWrapper}
					>
						Alterar
					</Button>
				</DialogActions>
			</Dialog>
		</div>
	);
};

export default ChangePasswordModal;
